module.exports = __webpack_public_path__ + "media/images/icon__infoBox@2x-49af015bef9da795f0df505c917fb8cd.png";